import { formatCnpj, formatCpf } from "./documento";

export function formatarParaMoedaBRL(valor: number): string {
    return !valor ? '' : valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  // Delega para a fonte única de formatação de documentos (CNPJ no novo modelo alfanumérico).
  export function formatarCNPJ(cnpj: string): string {
    return formatCnpj(cnpj);
  }

  export function formatarCPF(cpf: string): string {
    return formatCpf(cpf);
  }
  
  export const formatDate = (dateString: String) => {
    const day = dateString.toString().slice(6, 8);
    const year = dateString.toString().slice(0, 4);
    const month = dateString.toString().slice(4, 6);
  
    return `${day}/${month}/${year}`;
  };